var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "189.93 230 120.15 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.63 270H194.38c-2.5 0-4.45-2.2-4.45-5v-30c0-2.8 1.95-5 4.44-5h111.25c2.5 0 4.46 2.2 4.46 5v30c0 2.8-1.96 5-4.45 5z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M305.63 230.8c2.04 0 3.73 1.9 3.73 4.2v30c0 2.3-1.69 4.2-3.74 4.2H194.38c-2.04 0-3.73-1.9-3.73-4.2v-30c0-2.3 1.69-4.2 3.74-4.2h111.25m0-.8H194.38c-2.5 0-4.45 2.3-4.45 5v30c0 2.8 1.95 5 4.44 5h111.25c2.5 0 4.46-2.2 4.46-5v-30c0-2.7-1.96-5-4.45-5z",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M47.4 10.2c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2a2.94 2.94 0 0 1 4.3.1l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2v-.8h2.9v.4zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52v.7zm3.3 5.3h-.8V7.7h-1.7V7H57v.7h-1.7V13zm4.6 0V7h.8v6h-.8zm4.2 0h-.8V7.7h-1.7V7h4.1v.7H64V13zm9.5-.8c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7zm5.8 1.3V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13h-.7z",
    transform: "matrix(.89 0 0 1 189.93 230)",
    vectorEffect: "non-scaling-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250.53 251.8a3.53 3.53 0 0 0-2.73 1.23 4.49 4.49 0 0 0-1.1 3.07c0 2.4 1.7 4.3 3.83 4.3 2.14 0 3.83-1.8 3.83-4.3 0-2.6-1.69-4.3-3.83-4.3zm0 6.8c-1.15 0-2.13-1.1-2.13-2.6s.98-2.6 2.13-2.6c1.16 0 2.14 1 2.14 2.6 0 1.5-.98 2.6-2.14 2.6zm-8.27-6.8a3.53 3.53 0 0 0-2.74 1.23 4.49 4.49 0 0 0-1.09 3.07c0 2.4 1.7 4.3 3.83 4.3s3.82-1.8 3.82-4.3c0-2.6-1.69-4.3-3.82-4.3zm0 6.8c-1.16 0-2.14-1.1-2.14-2.6s.98-2.6 2.14-2.6c1.15 0 2.13 1 2.13 2.6 0 1.5-.98 2.6-2.13 2.6zm-9.88-5.5v1.8h3.83c-.1 1-.45 1.8-.9 2.3-.53.6-1.42 1.3-2.93 1.3-2.4 0-4.18-2.1-4.18-4.8a4.79 4.79 0 0 1 2.51-4.43 3.86 3.86 0 0 1 4.6.93l1.16-1.3a5.38 5.38 0 0 0-4-1.8c-3.2 0-5.97 3-5.97 6.6 0 3.6 2.76 6.6 5.97 6.6a4.9 4.9 0 0 0 4.1-1.9 6.47 6.47 0 0 0 1.42-4.2c0-.4 0-.8-.1-1.1h-5.51zm40.4 1.4c-.35-1-1.24-2.7-3.2-2.7-1.96 0-3.56 1.7-3.56 4.3 0 2.4 1.6 4.3 3.74 4.3a3.6 3.6 0 0 0 3.11-1.9l-1.24-1c-.45.7-.98 1.2-1.87 1.2-.9 0-1.43-.4-1.87-1.3l5.07-2.4-.18-.5zm-5.16 1.4c0-1.6 1.16-2.5 1.96-2.5.62 0 1.25.4 1.42.9l-3.38 1.6zm-4.18 4.1h1.69v-12.5h-1.7V260zm-2.67-7.3a2.8 2.8 0 0 0-2.05-1c-1.87 0-3.65 1.9-3.65 4.3s1.7 4.2 3.65 4.2c.9 0 1.6-.5 1.96-1h.09v.6c0 1.6-.8 2.5-2.05 2.5-.98 0-1.69-.8-1.87-1.5l-1.42.7c.44 1.1 1.51 2.5 3.38 2.5 1.96 0 3.56-1.3 3.56-4.4V252h-1.6v.7zm-1.96 5.9c-1.16 0-2.13-1.1-2.13-2.6s.97-2.6 2.13-2.6 2.05 1.1 2.05 2.6-.9 2.6-2.05 2.6zm21.72-11.1h-4V260h1.68v-4.7h2.32c1.87 0 3.65-1.5 3.65-3.9s-1.78-3.9-3.65-3.9zm.09 6h-2.4v-4.3h2.4c1.24 0 1.95 1.2 1.95 2.1-.08 1.1-.8 2.2-1.95 2.2zm10.23-1.8c-1.25 0-2.5.6-2.94 1.9l1.52.7c.35-.7.89-.9 1.51-.9.89 0 1.7.6 1.78 1.6v.1c-.27-.2-.98-.5-1.7-.5-1.6 0-3.2 1-3.2 2.8 0 1.7 1.34 2.8 2.76 2.8 1.16 0 1.7-.6 2.14-1.2h.09v1h1.6v-4.8c-.18-2.2-1.69-3.5-3.56-3.5zm-.18 6.9c-.53 0-1.33-.3-1.33-1.1 0-1 .98-1.3 1.78-1.3.71 0 1.07.2 1.51.4-.18 1.2-1.07 2-1.96 2zm9.35-6.6-1.87 5.4h-.09l-1.96-5.4h-1.78l2.94 7.6-1.7 4.2h1.7l4.54-11.8h-1.78zm-14.95 8h1.69v-12.5h-1.7V260z",
    vectorEffect: "non-scaling-stroke"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.89 0 0 1 204.61 250)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.8,
    x2: 5.02,
    y1: 33.29,
    y2: 16.51,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51%",
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M10.4 7.5c-.3.3-.4.8-.4 1.4V31c0 .6.2 1.1.5 1.4l.1.1L23 20.1v-.2L10.4 7.5z",
    transform: "translate(-16.5 -20)",
    vectorEffect: "non-scaling-stroke"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.89 0 0 1 214.82 250.05)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 33.83,
    x2: 9.64,
    y1: 22,
    y2: 22,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m27 24.3-4.1-4.1v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z",
    transform: "translate(-27.97 -20.05)",
    vectorEffect: "non-scaling-stroke"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.89 0 0 1 206.61 256.44)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 24.83,
    x2: 2.07,
    y1: 19.7,
    y2: -3.05,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M27.1 24.2 22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1l14.6-8.4",
    transform: "translate(-18.75 -26.44)",
    vectorEffect: "non-scaling-stroke"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.89 0 0 1 206.61 243.59)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 7.3,
    x2: 17.46,
    y1: 41.82,
    y2: 31.66,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M27.1 15.8 12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z",
    transform: "translate(-18.75 -13.59)",
    vectorEffect: "non-scaling-stroke"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m213.96 254.1-12.91 8.2c-.71.5-1.34.4-1.78 0l-.09.1.09.1c.44.4 1.07.5 1.78 0l12.9-8.4z",
    opacity: 0.2,
    vectorEffect: "non-scaling-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.18 262.3c-.27-.3-.35-.8-.35-1.4v.1c0 .6.17 1.1.44 1.4v-.1h-.09zm19.22-11-4.44 2.8.08.1 4.37-2.8c.62-.4.89-.9.89-1.4 0 .5-.36.9-.9 1.3z",
    opacity: 0.12,
    vectorEffect: "non-scaling-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m201.05 237.6 17.35 11.1c.54.4.9.8.9 1.3 0-.5-.27-1-.9-1.4l-17.35-11.1c-1.25-.8-2.22-.2-2.22 1.4v.1c0-1.5.97-2.2 2.22-1.4z",
    opacity: 0.25,
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.e12073cb9d390492c42ce796ea2d78ed.svg";
export { ForwardRef as ReactComponent };